import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewall',
  templateUrl: './viewall.component.html',
  styleUrls: ['./viewall.component.scss']
})
export class ViewallComponent implements OnInit {
  
  constructor( ) {
   
   }

  ngOnInit() {
  }
 
}
